/* ARCK ex-GST primary price display for B2B trade pages
 * The theme already renders BOTH prices (inc-GST big + ex-GST smaller) inside
 * each .productView-price block. This script SWAPS their visual hierarchy so
 * the ex-GST price is the primary/big/bold one and the inc-GST price is
 * demoted to a smaller secondary line — matching the ARCK template style.
 *
 * Also handles variant changes (re-applies after Shopify re-renders the price).
 * No theme file edits required; everything is done in the DOM.
 */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  // Exact values from arck-product.css (.arck-price / .arck-price--inc / .arck-price-label)
  // Desktop: big=36px, small=20px. Mobile: big=30px, small=18px.
  // Using clamp() so it scales naturally without a media query.
  var BIG_STYLE = 'display:inline-block;font-size:clamp(30px, 4vw, 36px);font-weight:700;color:#1a1a1a;line-height:1;';
  var SMALL_STYLE = 'display:inline-block;font-size:clamp(18px, 2.2vw, 20px);color:#666;font-weight:600;line-height:1;';
  var LABEL_STYLE = 'font-size:13px;color:#666;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;margin-left:8px;line-height:1;';
  var ROW_STYLE = 'display:flex;align-items:baseline;gap:8px;margin-bottom:4px;';
  var ROW_SMALL_STYLE = 'display:flex;align-items:baseline;gap:8px;';
  var STAMP_ATTR = 'data-arck-ex-gst-restyled';

  function moneyOnly(text) {
    if (!text) return null;
    var m = text.match(/\$\s*[\d,]+(?:\.\d+)?/);
    return m ? m[0].replace(/\s+/g, '') : null;
  }

  function processDt(dt) {
    if (!dt || dt.getAttribute(STAMP_ATTR) === '1') return;
    // The dt typically contains 2 direct spans: first big (inc GST), second smaller (ex GST)
    var spans = dt.querySelectorAll(':scope > span');
    if (spans.length < 2) return;

    var incSpan = spans[0];
    var exSpan = spans[1];

    // If the second span doesn't look like an ex-GST line, bail out
    var exHasLabel = /ex\s*gst/i.test(exSpan.textContent);
    if (!exHasLabel) return;

    var inc = moneyOnly(incSpan.textContent);
    var ex = moneyOnly(exSpan.textContent);
    if (!inc || !ex) return;

    // Mark BEFORE mutating so the MutationObserver doesn't loop
    dt.setAttribute(STAMP_ATTR, '1');

    incSpan.outerHTML =
      '<div style="' + ROW_STYLE + '">' +
        '<span style="' + BIG_STYLE + '">' + ex + '</span>' +
        '<span style="' + LABEL_STYLE + '">EX GST</span>' +
      '</div>';
    exSpan.outerHTML =
      '<div style="' + ROW_SMALL_STYLE + '">' +
        '<span style="' + SMALL_STYLE + '">' + inc + '</span>' +
        '<span style="' + LABEL_STYLE + '">INC GST</span>' +
      '</div>';
  }

  function processContainer(container) {
    // Handles both .price__regular and .price__sale variants
    container.querySelectorAll('.price__regular dt, .price__sale dt, .price-item-container dt').forEach(processDt);
  }

  function init() {
    var containers = document.querySelectorAll('.productView-price, [id^="product-price-"]');
    if (containers.length === 0) return;
    containers.forEach(function (c) {
      processContainer(c);
      // Watch for variant-change re-renders; if Shopify replaces the dt subtree
      // our stamp is gone, so we restyle again.
      new MutationObserver(function () { processContainer(c); }).observe(c, {
        childList: true,
        subtree: true
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
